const LoginRecommend = {
  GOOGLE: 'GOOGLE',
  SSO: 'SSO',
  HUBSPOT: 'HUBSPOT',
  APPLE: 'APPLE',
  MICROSOFT: 'MICROSOFT'
};
export default LoginRecommend;